/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'
import { productUrl } from '@helpers/route'
import { useTest } from '@hooks/useTest'
import { addToDataLayer } from '@helpers/google-tag-manager'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const AbsoluteAnchor = () => {
  const { collection, activeColor } = useBaseCollectionTileContext()
  const { baseRoute, variations, title } = collection ?? {}
  const { generateTestId } = useTest()
  const route = variations?.[activeColor]?.route ?? baseRoute
  if (!route) return null
  return (
    <a
      href={productUrl(route)}
      data-testid={generateTestId('collection-tile', 'card-link')}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
      onClick={() => {
        addToDataLayer('click', 'CLP', 'CTA Click', title, 'Collection Tile card click')
      }}
    />
  )
}

export default AbsoluteAnchor
